export default __webpack_public_path__ + "static/media/BG.79402cb2.png";